import { render } from "./Recycle.vue?vue&type=template&id=3075a9f8&scoped=true"
import script from "./Recycle.vue?vue&type=script&lang=js"
export * from "./Recycle.vue?vue&type=script&lang=js"

import "./Recycle.vue?vue&type=style&index=0&id=3075a9f8&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3075a9f8"]])

export default __exports__